import { Button, MagellanPopup } from 'components/atoms';
import InstrumentalSelectCard from 'components/molecules/card/instrumental-select/InstrumentalSelectCard';
import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Popup from 'reactjs-popup';
import { PopupActions } from 'reactjs-popup/dist/types';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';

interface IInstrumentalSelectPopupFormProps {
  trigger?: JSX.Element | ((isOpen: boolean) => JSX.Element) | undefined;
  onSelectInstrumental?: (instrumental: boolean | null, actions: PopupActions) => void;
  open?: boolean;
  initialInstrumental?: boolean | null;
  displayMode?: boolean;
}

const InstrumentalSelectPopupForm = ({
  trigger,
  onSelectInstrumental,
  open,
  initialInstrumental = null,
  displayMode,
}: IInstrumentalSelectPopupFormProps) => {
  const popupRef = useRef<PopupActions | null>(null);
  const { t } = useTranslation();

  const [selectedInstrumental, setSelectedInstrumental] = useState<boolean | null>(null);

  return displayMode ? (
    <>{trigger}</>
  ) : (
    <Popup
      ref={popupRef}
      open={open}
      onOpen={() => {
        setSelectedInstrumental(initialInstrumental);
      }}
      onClose={() => {
        setSelectedInstrumental(null);
      }}
      modal
      nested
      trigger={trigger}
    >
      <MagellanPopup>
        <MagellanPopup.Header>{t('input.label.instrumental')}</MagellanPopup.Header>

        <div className="flex flex-col w-full max-w-96 overflow-auto h-[450px] [scrollbar-width:none]  gap-2">
          {[false, true].map((instrumental) => (
            <InstrumentalSelectCard
              key={String(instrumental)}
              instrumental={instrumental}
              isSelected={selectedInstrumental === instrumental}
              onClick={(newInstrumental) =>
                setSelectedInstrumental((prev) =>
                  prev === newInstrumental ? null : newInstrumental,
                )
              }
            />
          ))}
        </div>
        <div className="flex justify-between w-full">
          <Button isClear onClick={() => popupRef.current?.close()}>
            <Button.Text text={t('button.cancel')} />
          </Button>
          <Button
            variant={BUTTON_VARIANT.submit}
            onClick={() =>
              popupRef.current &&
              onSelectInstrumental &&
              onSelectInstrumental(selectedInstrumental, popupRef.current)
            }
          >
            <Button.Text text={t('button.save')} />
          </Button>
        </div>
      </MagellanPopup>
    </Popup>
  );
};

export default InstrumentalSelectPopupForm;
